'use client'
import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import nProgress from 'nprogress'
import { REVIVE_ID } from '@/shared/constants'

export default function NProgressBar() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  useEffect(() => {
    try {
      nProgress.done()
      const script = document.querySelector(
        `script[src="//servedby.revive-adserver.net/asyncjs.php"]`
      )
      if (script) {
        if (window?.reviveAsync?.[REVIVE_ID]) {
          window.reviveAsync[REVIVE_ID].seq = 0
        }
        script?.remove()
      }
    } catch (error) {
      console.log('Error while removing revive script:', error)
    }
  }, [pathname, searchParams])
  return null
}
